var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('malattie-infettive-list-component',{attrs:{"pathResource":_vm.pathResource,"utente":_vm.utente,"fonte":'/segnalazioni'}})}
var staticRenderFns = []

export { render, staticRenderFns }